import React from "react";
import "./css/divisorDown.css";
import PropTypes from "prop-types";

const DivisorDown = ({ supremeTitle = null, title, subtitle, text = null }) => {
  return (
    <div className="container my-4">
      {/* Título superior */}
      <div className="color-text-gris-40-hv mb-2">{supremeTitle}</div>

      {/* Línea responsive */}
      <div className="w-100 border-bottom border-custom mb-3"></div>

      {/* Título */}
      <div>
        <div
          className="color-text-gris-20-hv"
          dangerouslySetInnerHTML={{
            __html: title.replace(/ ([^ ]*)$/, "&nbsp;$1"),
          }}
        />
      </div>

      {/* Contenido responsive */}
      <div className="row mt-2">
        <div className="col-12 col-md-8 d-flex flex-column">
          <div className="color-text-body-children-hv text-baseline-fix ">
            {subtitle}
          </div>

          <div className="color-text-body-children-hv text-baseline-fix">
            {text}
          </div>
        </div>
      </div>
    </div>
  );
};

DivisorDown.propTypes = {
  supremeTitle: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  text: PropTypes.string,
};

export default DivisorDown;
